import React, { useEffect, useState } from "react";
import Popup from "../components/Popup";
import { Typography } from "@mui/material";
import mail from "../../../../Assets/img/Login/mail.png";
import OtpPopup from "./OtpPopup";

const EmailSuccessful = ({ isOpen, onClose , email}) => {
  const [showOtp, setShowOtp] = useState(false);

  const handleOtpPopup = () => {
    setShowOtp(!showOtp);
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setShowOtp(true);
      }, 5000); // 10 seconds
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <>
      <Popup
        isOpen={isOpen && !showOtp}
        onClose={onClose}
        image={mail}
        text="Email Sent Successfully"
      >
        <Typography
          variant="subtitle1"
          sx={{ textAlign: "center", width: "360px" }}
        >
          We've sent password reset instructions to your email. Please check
          your inbox.
        </Typography>
      </Popup>
      <OtpPopup isOpen={showOtp} onClose={handleOtpPopup} email={email}/>
    </>
  );
};

export default EmailSuccessful;
